import { FileUploader, Select, Checkbox, Button, Slider, Container, TextInput } from '../ui/pageElements';
import { round } from '../helpers';
import * as T from 'three';

const LIST_CONTAINER = "jointListContainer"

export class JointInterface {
    constructor(robot, parent, interfaces) {
        this.rotationParent = robot.parent
        this.interfaces = interfaces;
        this.jointSliders = [];
        this.jointContainer = new Container("jointContainer-" + robot.name, LIST_CONTAINER, true);;
        this.robotIndex = 0;
        this.robot = robot;
        this.parent = parent;
        this.positionSliderNames = [
            "Scale",
            "X Position",
            "Y Position",
            "Z Position",
            "X Rotation",
            "Y Rotation",
            "Z Rotation"
        ]

        this.offsets = {
            X_POS_OFFSET: 0,
            Y_POS_OFFSET: 1,
            Z_POS_OFFSET: 0,
            X_ROT_OFFSET: 0,
            Y_ROT_OFFSET: 0,
            Z_ROT_OFFSET: 0,
        }

        const MAX_POSITION = 2;

        let createPositionSliders = (container, jointSliders, parent, isLink) => {
            let header = "";
            if (isLink) {
                header += robot.name + " ";
            }
            if (!isLink) {
                let scaleSlider = new Slider(header + "Scale", LIST_CONTAINER, 0.1, 2, 0.01, 1);
                scaleSlider.slider.oninput = () => {
                    scaleSlider.label.innerHTML = header + "Scale: " + String(scaleSlider.slider.value);
                    let scale = Number(scaleSlider.slider.value);
                    robot.scale.set(scale, scale, scale)
                }
                jointSliders.push(scaleSlider);
                container.addBlock(scaleSlider);
            }

            let xPosSlider = new Slider("X Position", LIST_CONTAINER, -MAX_POSITION, MAX_POSITION, 0.01, 0);
            xPosSlider.label.innerHTML = header + "X Position: 0";
            xPosSlider.slider.oninput = () => {
                xPosSlider.label.innerHTML = header + "X Position: " + String(xPosSlider.slider.value);
                parent.position.x = Number(xPosSlider.slider.value) + this.offsets.X_POS_OFFSET;
            }
            parent.position.x = Number(xPosSlider.slider.value) + this.offsets.X_POS_OFFSET;
            jointSliders.push(xPosSlider);
            container.addBlock(xPosSlider);

            // temp fix for swapping y and z for links
            let yPosSlider = new Slider("Y Position", LIST_CONTAINER, -MAX_POSITION, MAX_POSITION, 0.01, 0);
            yPosSlider.label.innerHTML = header + "Y Position: 0";
            yPosSlider.slider.oninput = () => {
                yPosSlider.label.innerHTML = header + "Y Position: " + String(yPosSlider.slider.value);
                parent.position.y = Number(yPosSlider.slider.value) + this.offsets.Y_POS_OFFSET;
            }
            parent.position.y = Number(yPosSlider.slider.value) + this.offsets.Y_POS_OFFSET;
            jointSliders.push(yPosSlider);
            container.addBlock(yPosSlider);

            let zPosSlider = new Slider("Z Position", LIST_CONTAINER, -MAX_POSITION, MAX_POSITION, 0.01, 0);
            zPosSlider.label.innerHTML = header + "Z Position: 0";
            zPosSlider.slider.oninput = () => {
                zPosSlider.label.innerHTML = header + "Z Position: " + String(zPosSlider.slider.value);
                parent.position.z = Number(zPosSlider.slider.value) + this.offsets.Z_POS_OFFSET;
            }
            parent.position.z = Number(zPosSlider.slider.value) + this.offsets.Z_POS_OFFSET;
            jointSliders.push(zPosSlider);
            container.addBlock(zPosSlider);

            let xRotSlider = new Slider("X Rotation", LIST_CONTAINER, -Math.PI, Math.PI, 0.01, 0);
            xRotSlider.label.innerHTML = header + "X Rotation: 0";
            xRotSlider.slider.oninput = () => {
                xRotSlider.label.innerHTML = header + "X Rotation: " + String(xRotSlider.slider.value);
                parent.rotation.x = Number(xRotSlider.slider.value) //+ Number(isLink ? 0 : this.offsets.X_ROT_OFFSET);
            }
            parent.rotation.x = Number(xRotSlider.slider.value) //+ Number(isLink ? 0 : this.offsets.X_ROT_OFFSET);
            jointSliders.push(xRotSlider);
            container.addBlock(xRotSlider);

            // y and z are swapped since robot is rotated on x axis by pi/2
            let yRotSlider = new Slider("Y Rotation", LIST_CONTAINER, -Math.PI, Math.PI, 0.01, 0);
            yRotSlider.label.innerHTML = header + "Y Rotation: 0";
            yRotSlider.slider.oninput = () => {
                yRotSlider.label.innerHTML = header + "Y Rotation: " + String(yRotSlider.slider.value);
                parent.rotation.y = Number(yRotSlider.slider.value) //+ Number(isLink ? 0 : this.offsets.Y_ROT_OFFSET);
            }
            parent.rotation.y = Number(yRotSlider.slider.value) //+ Number(isLink ? 0 : this.offsets.Y_ROT_OFFSET);
            jointSliders.push(yRotSlider);
            container.addBlock(yRotSlider);

            let zRotSlider = new Slider("Z Rotation", LIST_CONTAINER, -Math.PI, Math.PI, 0.01, 0);
            zRotSlider.label.innerHTML = header + "Z Rotation: 0";
            zRotSlider.slider.oninput = () => {
                zRotSlider.label.innerHTML = header + "Z Rotation: " + String(zRotSlider.slider.value);
                // parent.rotation.z = -(Number(zRotSlider.slider.value) + Number(isLink ? 0 : this.offsets.Z_ROT_OFFSET));
                parent.rotation.z = Number(zRotSlider.slider.value);
            }
            // parent.rotation.z = -(Number(zRotSlider.slider.value) + Number(isLink ? 0 : this.offsets.Z_ROT_OFFSET));
            parent.rotation.z = Number(zRotSlider.slider.value);
            jointSliders.push(zRotSlider);
            container.addBlock(zRotSlider);
        }

        let createRelativePositionSliders = (container, jointSliders, robot, isLink) => {
            let header = "";
            if (isLink) {
                header += robot.name + " ";
            }

            let xPosSlider = new Slider("Local X Position", LIST_CONTAINER, -MAX_POSITION, MAX_POSITION, 0.01, 0);
            xPosSlider.label.innerHTML = header + "Local X Position: 0";
            xPosSlider.slider.oninput = () => {
                xPosSlider.label.innerHTML = header + "Local X Position: " + String(xPosSlider.slider.value);
                this.rotationParent.position.x = Number(xPosSlider.slider.value)// +  Number(isLink ? 0 : this.offsets.X_POS_OFFSET);
            }
            this.rotationParent.position.x = Number(xPosSlider.slider.value)// + Number(isLink ? 0 : this.offsets.X_POS_OFFSET);
            jointSliders.push(xPosSlider);
            container.addBlock(xPosSlider);

            // temp fix for swapping y and z for links
            let yPosSlider = new Slider("Local Y Position", LIST_CONTAINER, -MAX_POSITION, MAX_POSITION, 0.01, 0);
            yPosSlider.label.innerHTML = header + "Local Y Position: 0";
            yPosSlider.slider.oninput = () => {
                yPosSlider.label.innerHTML = header + "Local Y Position: " + String(yPosSlider.slider.value);
                if (isLink) {
                    this.rotationParent.position.z = Number(yPosSlider.slider.value);
                } else {
                    this.rotationParent.position.y = Number(yPosSlider.slider.value)// + this.offsets.Y_POS_OFFSET;
                }
            }
            if (isLink) {
                this.rotationParent.position.z = Number(yPosSlider.slider.value);
            } else {
                this.rotationParent.position.y = Number(yPosSlider.slider.value)// + this.offsets.Y_POS_OFFSET;
            }
            jointSliders.push(yPosSlider);
            container.addBlock(yPosSlider);

            let zPosSlider = new Slider("Local Z Position", LIST_CONTAINER, -MAX_POSITION, MAX_POSITION, 0.01, 0);
            zPosSlider.label.innerHTML = header + "Local Z Position: 0";
            zPosSlider.slider.oninput = () => {
                zPosSlider.label.innerHTML = header + "Local Z Position: " + String(zPosSlider.slider.value);
                if (isLink) {
                    this.rotationParent.position.y = Number(zPosSlider.slider.value);
                } else {
                    this.rotationParent.position.z = Number(zPosSlider.slider.value)// + this.offsets.Z_POS_OFFSET;
                }
            }
            if (isLink) {
                this.rotationParent.position.y = Number(zPosSlider.slider.value);
            } else {
                this.rotationParent.position.z = Number(zPosSlider.slider.value)// + this.offsets.Z_POS_OFFSET;
            }
            jointSliders.push(zPosSlider);
            container.addBlock(zPosSlider);

            let xRotSlider = new Slider("Local X Rotation", LIST_CONTAINER, -Math.PI, Math.PI, 0.01, 0);
            xRotSlider.label.innerHTML = header + "Local X Rotation: 0";
            xRotSlider.slider.oninput = () => {
                xRotSlider.label.innerHTML = header + "Local X Rotation: " + String(xRotSlider.slider.value);
                this.rotationParent.rotation.x = Number(xRotSlider.slider.value) + Number(isLink ? 0 : this.offsets.X_ROT_OFFSET);
            }
            this.rotationParent.rotation.x = Number(xRotSlider.slider.value) + Number(isLink ? 0 : this.offsets.X_ROT_OFFSET);
            jointSliders.push(xRotSlider);
            container.addBlock(xRotSlider);

            // y and z are swapped since robot is rotated on x axis by pi/2
            let yRotSlider = new Slider("Local Y Rotation", LIST_CONTAINER, -Math.PI, Math.PI, 0.01, 0);
            yRotSlider.label.innerHTML = header + "Local Y Rotation: 0";
            yRotSlider.slider.oninput = () => {
                yRotSlider.label.innerHTML = header + "Local Y Rotation: " + String(yRotSlider.slider.value);
                this.rotationParent.rotation.z = Number(yRotSlider.slider.value) + Number(isLink ? 0 : this.offsets.Y_sROT_OFFSET);
            }
            this.rotationParent.rotation.z = Number(yRotSlider.slider.value) + Number(isLink ? 0 : this.offsets.Y_ROT_OFFSET);
            jointSliders.push(yRotSlider);
            container.addBlock(yRotSlider);

            let zRotSlider = new Slider("Local Z Rotation", LIST_CONTAINER, -Math.PI, Math.PI, 0.01, 0);
            zRotSlider.label.innerHTML = header + "Local Z Rotation: 0";
            zRotSlider.slider.oninput = () => {
                zRotSlider.label.innerHTML = header + "Local Z Rotation: " + String(zRotSlider.slider.value);
                // robot.rotation.z = Number(zRotSlider.slider.value);
                this.rotationParent.rotation.y = -(Number(zRotSlider.slider.value) + Number(isLink ? 0 : this.offsets.Z_ROT_OFFSET));
            }
            // robot.rotation.z = Number(zRotSlider.slider.value);
            this.rotationParent.rotation.y = -(Number(zRotSlider.slider.value) + Number(isLink ? 0 : this.offsets.Z_ROT_OFFSET));
            jointSliders.push(zRotSlider);
            container.addBlock(zRotSlider);
        }


        createPositionSliders(this.jointContainer, this.jointSliders, this.parent, false);
        createRelativePositionSliders(this.jointContainer, this.jointSliders, this.robot, false);

        this.jointArr = Object.entries(this.robot.joints).filter(joint => joint[1]._jointType != "fixed" && joint[1].type != "URDFMimicJoint");
        this.jointArr.forEach(joint => {
            if (joint[1]._jointType == "floating") {
                // console.log(joint[1])
                let childLinks = joint[1].children;
                childLinks.forEach(link => {
                    createPositionSliders(this.jointContainer, this.jointSliders, link, true);
                })
            }
            else {
                let step = (joint[1].limit.upper - joint[1].limit.lower) / 1000;
                let sliderDiv = new Slider(joint[0], LIST_CONTAINER, joint[1].limit.lower, joint[1].limit.upper, step < 0.1 ? step : 0.1, joint[1].jointValue[0]);
                sliderDiv.div.classList.add("jointSliderDiv");
                this.jointContainer.addBlock(sliderDiv);
                sliderDiv.slider.oninput = () => {
                    sliderDiv.label.innerHTML = joint[0] + ": " + String(sliderDiv.slider.value);
                    this.robot.setJointValue(joint[0], sliderDiv.slider.value);
                }
                this.jointSliders.push(sliderDiv);
            }
        })
    }

    updateSliders() {
        this.jointArr.forEach(joint => {
            let sliderDiv = this.jointSliders.find(element => element.slider.id.trim() == `${joint[0]}-slider`);
            sliderDiv.slider.value = joint[1].jointValue[0];
            sliderDiv.label.innerHTML = joint[0] + ": " + String(sliderDiv.slider.value);
        })
        this.jointSliders[1].slider.value = this.parent.position.x - this.offsets.X_POS_OFFSET
        this.jointSliders[1].label.innerHTML = "X Position: " + String(this.jointSliders[1].slider.value);
        this.jointSliders[2].slider.value = this.parent.position.y - this.offsets.Y_POS_OFFSET
        this.jointSliders[2].label.innerHTML = "Y Position: " + String(this.jointSliders[2].slider.value);
        this.jointSliders[3].slider.value = this.parent.position.z - this.offsets.Z_POS_OFFSET
        this.jointSliders[3].label.innerHTML = "Z Position: " + String(this.jointSliders[3].slider.value);
        this.jointSliders[4].slider.value = this.parent.rotation.x
        this.jointSliders[4].label.innerHTML = "X Rotation: " + String(this.jointSliders[4].slider.value);
        this.jointSliders[5].slider.value = this.parent.rotation.z
        this.jointSliders[5].label.innerHTML = "Y Rotation: " + String(this.jointSliders[5].slider.value);
        this.jointSliders[6].slider.value = this.parent.rotation.y
        this.jointSliders[6].label.innerHTML = "Z Rotation: " + String(this.jointSliders[6].slider.value);

        this.jointSliders[7].slider.value = this.rotationParent.position.x
        this.jointSliders[7].label.innerHTML = "Local X Position: " + String(this.jointSliders[7].slider.value);
        this.jointSliders[8].slider.value = this.rotationParent.position.y
        this.jointSliders[8].label.innerHTML = "Local Y Position: " + String(this.jointSliders[8].slider.value);
        this.jointSliders[9].slider.value = this.rotationParent.position.z
        this.jointSliders[9].label.innerHTML = "Local Z Position: " + String(this.jointSliders[9].slider.value);
        this.jointSliders[10].slider.value = this.rotationParent.rotation.x - this.offsets.X_ROT_OFFSET
        this.jointSliders[10].label.innerHTML = "Local X Rotation: " + String(this.jointSliders[10].slider.value);
        this.jointSliders[11].slider.value = this.rotationParent.rotation.z - this.offsets.Y_ROT_OFFSET
        this.jointSliders[11].label.innerHTML = "Local Y Rotation: " + String(this.jointSliders[11].slider.value);
        this.jointSliders[12].slider.value = this.rotationParent.rotation.y - this.offsets.Z_ROT_OFFSET
        this.jointSliders[12].label.innerHTML = "Local Z Rotation: " + String(this.jointSliders[12].slider.value);
    }

    // configs should be an array of values
    setJoints(config) {
        for (let i = 0; i < this.jointSliders.length; i++) {
            let sliderDiv = this.jointSliders[i];
            sliderDiv.slider.value = config[i];
            if (i < 13) {
                sliderDiv.label.innerHTML = this.positionSliderNames[i] + ": " + String(sliderDiv.slider.value);
                switch (i) {
                    case 0:
                        let scale = Number(sliderDiv.slider.value);
                        this.robot.scale.set(scale, scale, scale)
                        break;
                    case 1:
                        this.parent.position.x = Number(sliderDiv.slider.value) + this.offsets.X_POS_OFFSET;
                        break;
                    case 2:
                        this.parent.position.y = Number(sliderDiv.slider.value) + this.offsets.Y_POS_OFFSET;
                        break;
                    case 3:
                        this.parent.position.z = Number(sliderDiv.slider.value) + this.offsets.Z_POS_OFFSET;
                        break;
                    case 4:
                        this.parent.rotation.x = Number(sliderDiv.slider.value)// + this.offsets.X_ROT_OFFSET;
                        break;
                    // y and z are swapped since robot is rotated on x axis by pi/2
                    case 5:
                        this.parent.rotation.y = Number(sliderDiv.slider.value)// + this.offsets.Y_ROT_OFFSET;
                        break;
                    case 6:
                        this.parent.rotation.z = Number(sliderDiv.slider.value)// + this.offsets.Z_ROT_OFFSET;
                        break;
                    case 7:
                        this.rotationParent.position.x = Number(sliderDiv.slider.value)// + this.offsets.X_POS_OFFSET;
                        break;
                    case 8:
                        this.rotationParent.position.y = Number(sliderDiv.slider.value) //+ this.offsets.Y_POS_OFFSET;
                        break;
                    case 9:
                        this.rotationParent.position.z = Number(sliderDiv.slider.value) //+ this.offsets.Z_POS_OFFSET;
                        break;
                    case 10:
                        this.rotationParent.rotation.x = Number(sliderDiv.slider.value) + this.offsets.X_ROT_OFFSET;
                        break;
                    // y and z are swapped since robot is rotated on x axis by pi/2
                    case 11:
                        this.rotationParent.rotation.y = Number(sliderDiv.slider.value) + this.offsets.Y_ROT_OFFSET;
                        break;
                    case 12:
                        this.rotationParent.rotation.z = Number(sliderDiv.slider.value) + this.offsets.Z_ROT_OFFSET;
                        break;
                }
            }
            else if(this.jointArr[i - 13]) {
                if (this.jointArr[i - 13][1]._jointType == "floating") {
                    let childLinks = this.jointArr[i - 13][1].children;
                    let k = 0;
                    childLinks.forEach(link => {
                        for (let j = 0; j < 6; j++) {
                            let linkSliderDiv = this.jointSliders[i + k + j];
                            linkSliderDiv.slider.value = config[i + k + j];
                            switch ((i + k + j - 7) % 6) {
                                case 0:
                                    link.position.x = Number(sliderDiv.slider.value);
                                    break;
                                // y and z swapped for position only on links
                                case 1:
                                    link.position.z = Number(sliderDiv.slider.value);
                                    break;
                                case 2:
                                    link.position.y = Number(sliderDiv.slider.value);
                                    break;
                                case 3:
                                    link.rotation.x = Number(sliderDiv.slider.value);
                                    break;
                                // y and z are now swapped for links
                                case 4:
                                    link.rotation.y = Number(sliderDiv.slider.value);
                                    break;
                                case 5:
                                    link.rotation.z = Number(sliderDiv.slider.value);
                                    break;
                            }
                        }
                        k += 6;
                    })
                    i += k;
                }
                else {
                    sliderDiv.label.innerHTML = this.jointArr[i - 13][0] + ": " + String(sliderDiv.slider.value);
                    this.robot.setJointValue(this.jointArr[i - 13][0], sliderDiv.slider.value);
                }
            }
        }
    }

    getJointConfigsNames() {
        return this.jointSliders.map(sliderDiv => sliderDiv.name);
    }

    getJointConfigs(ignoreSliders = false) {
        let configs = []
        if(ignoreSliders) {
            let jointArr = Object.entries(this.robot.joints).filter(joint => joint[1]._jointType != "fixed" && joint[1].type != "URDFMimicJoint");
            jointArr.forEach(joint => {
                configs.push(joint[1].jointValue[0])
            })
        }
        else {
            this.jointSliders.map(sliderDiv => Number(sliderDiv.slider.value)).forEach(config => {
                configs.push(config)
            })
        }
        return configs
    }

    getJoints() {
        return this.jointArr;
    }

    hideUI() {
        this.jointSliders.forEach(slider => {
            slider.removeDiv();
        })
    }

    showUI() {
        this.jointSliders.forEach(slider => {
            slider.addDiv();
        })
    }
}